import { COLORS } from '@btime/constants'
import React from 'react'

import { Text } from '../presentation/Text'
import DropdownLink from '../navigation/DropdownLink'
import FlexGrid, { FlexColumn } from '../structure/FlexGrid'
import ListItemWrapper from './ListItemWrapper'

const DropdownListItem = ({ label, value, cleanLabel, ...props }) => {
  return (
    <ListItemWrapper {...props}>
      <FlexGrid justify="flex-start" gutter={0.3}>
        <FlexColumn flex={1}>{cleanLabel ? label : <Text>{label}</Text>}</FlexColumn>
        <DropdownLink label={value} size="xsmall" color={COLORS.dark3} fromRight {...props} />
      </FlexGrid>
    </ListItemWrapper>
  )
}

export default DropdownListItem
